import React from 'react';
import IconWrapper from '../../../IconWrapper';
const ArrowRightIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { d: "M18.793 12.5H4v-1h14.793l-7.146-7.146.707-.708L20.707 12l-8.353 8.354-.707-.707 7.146-7.147Z" })));
export default ArrowRightIconMedium;
//# sourceMappingURL=ArrowRightIconMedium.js.map